import { defineComponent as _defineComponent } from 'vue'
import { computed, type ComputedRef } from "vue";
import { useRoute } from "vue-router";
import type { SideBarLink } from "@/types/entities/SideBarLink";
import routesName from "@/utils/constants/routesName";
import routesMetaTypes from "@/utils/constants/routesMetaTypes";
import { useUIStore } from "@/store/ui";
import { storeToRefs } from "pinia";
import { useUserStore } from "@/store/user";
import { UserRoleEnum } from "@/utils/enum/UserRoleEnum";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppSidebar',
  setup(__props, { expose }) {
  expose();

const route = useRoute();
const { userRole } = storeToRefs(useUserStore());

const { collapsed } = storeToRefs(useUIStore());
const { collapseSidebar } = useUIStore();

const allLinks: SideBarLink[] = [
  {
    name: "Orders",
    iconName: "icon_video-library",
    route: routesName.orders,
    routeType: routesMetaTypes.orders,
    allowedRoles: [UserRoleEnum.admin, UserRoleEnum.manager],
  },
  {
    name: "Distributions",
    iconName: "icon_distribution",
    route: routesName.distributions,
    routeType: routesMetaTypes.distributions,
    allowedRoles: [
      UserRoleEnum.admin,
      UserRoleEnum.manager,
      UserRoleEnum.distributionManager,
    ],
  },
  {
    name: "Videographers",
    iconName: "icon_camera",
    route: routesName.videographers,
    routeType: routesMetaTypes.videographers,
    allowedRoles: [UserRoleEnum.admin, UserRoleEnum.manager],
  },
  {
    name: "Corporate Clients",
    iconName: "icon_smile",
    route: routesName.corporateClients,
    routeType: routesMetaTypes.corporateClients,
    allowedRoles: [UserRoleEnum.admin, UserRoleEnum.manager],
  },
  {
    name: "Users",
    iconName: "icon_people",
    route: routesName.usersIndex,
    routeType: routesMetaTypes.users,
    allowedRoles: [UserRoleEnum.admin],
  },
  {
    name: "Coupons",
    iconName: "icon_coupon",
    route: routesName.coupons,
    routeType: routesMetaTypes.coupons,
    allowedRoles: [UserRoleEnum.admin, UserRoleEnum.manager],
  },
  {
    name: "Statistics",
    iconName: "icon_statistics",
    route: routesName.statistics,
    routeType: routesMetaTypes.statistics,
    allowedRoles: [UserRoleEnum.admin, UserRoleEnum.manager],
  },
];
const availableLinks: ComputedRef<SideBarLink[]> = computed(() => {
  if (!userRole.value) {
    return [];
  }

  return allLinks.filter((link) => {
    if (link.allowedRoles && userRole.value) {
      return link.allowedRoles.includes(userRole.value);
    }

    return true;
  });
});

const currentRouteType: ComputedRef<string> = computed(
  () => route.meta.type || ""
);

const __returned__ = { route, userRole, collapsed, collapseSidebar, allLinks, availableLinks, currentRouteType, computed, useRoute, routesName, routesMetaTypes, useUIStore, storeToRefs, useUserStore, UserRoleEnum }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})